export function extractProviderName(url: string): string {
  const parsedUrl = new URL(url);

  const { hostname } = parsedUrl;

  const parts = hostname.split('.');

  if (parts[0] === 'ra' && parts[1] === 'co') {
    return 'ra.co';
  }

  if (parts.length === 2) {
    return parts[0];
  }

  // This works for standard domains and some subdomains
  return parts.length > 2 ? parts[parts.length - 2] : '';
}
